import moment from 'moment';
import {
	YEAR_MONTH_DAY_SLASH,
	HOURS_MINUTES_COLON,
	HOURS_MINUTES_SECONDS_COLON,
} from 'utils/constants';

export const getFormattedStringDate = (
	date: Date | string | null,
	dateFormat: string = YEAR_MONTH_DAY_SLASH,
) => {
	if (!date) return '';
	return moment(date).format(dateFormat);
};

export const getFormattedStringTime = (
	time: string,
	timeFormat: string = HOURS_MINUTES_COLON,
) => {
	return moment(time, HOURS_MINUTES_SECONDS_COLON).format(timeFormat);
};

export const getMaxStartDate = (date: string) => {
	return moment(date).subtract(1, 'days').toDate();
};

export const getMinEndDate = (date: string) => {
	const endDate = moment(date).add(1, 'days');
	const currentDate = moment();
	return currentDate > endDate ? currentDate.toDate() : endDate.toDate();
};

export const getHHMMTimeFromHHMMSS = (time: string) => time.substr(0, 5);
